import React from 'react';

const CloseIcon: React.FC<{ size?: number }> = ({ size }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.35307 2.35299L13.6472 13.6471"
        stroke="#333F48"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.647 2.35307L2.35289 13.6472"
        stroke="#333F48"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

CloseIcon.defaultProps = {
  size: 16,
};

export { CloseIcon };
